export default __webpack_public_path__ + "static/media/PR.STREAK.TWELVE_MONTHS.54c545fe.jpg";